import { standardActCodes as defaultStandardActCodes } from "./data";

const STORAGE_KEY = "safecheck-standard-act-codes";

export function loadStandardActCodes(): StandardActCode[] {
  if (typeof window === "undefined") return defaultStandardActCodes;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return defaultStandardActCodes;
    const parsed = JSON.parse(stored) as StandardActCode[];
    return Array.isArray(parsed) ? parsed : defaultStandardActCodes;
  } catch {
    return defaultStandardActCodes;
  }
}

export function saveStandardActCodes(acts: StandardActCode[]) {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(acts));
}

export function getStandardActCodeById(id: string): StandardActCode | undefined {
  return loadStandardActCodes().find((act) => act.id === id);
}

export function createStandardActCode(
  acts: StandardActCode[],
  payload: Omit<StandardActCode, "id">,
): StandardActCode[] {
  const next: StandardActCode = {
    id: String(Date.now()),
    ...payload,
  };
  const updated = [...acts, next];
  saveStandardActCodes(updated);
  return updated;
}

export function updateStandardActCode(
  acts: StandardActCode[],
  id: string,
  payload: Omit<StandardActCode, "id">,
): StandardActCode[] {
  const updated = acts.map((act) => (act.id === id ? { ...act, ...payload } : act));
  saveStandardActCodes(updated);
  return updated;
}

export function deleteStandardActCode(acts: StandardActCode[], id: string): StandardActCode[] {
  const updated = acts.filter((act) => act.id !== id);
  saveStandardActCodes(updated);
  return updated;
}

export function exportStandardActCodesCsv(
  acts: StandardActCode[],
  headers: Record<"code" | "name" | "category" | "specialty" | "description", string>,
) {
  const rows = [
    [headers.code, headers.name, headers.category, headers.specialty, headers.description].join(","),
    ...acts.map((act) =>
      [act.code, act.label, act.category, act.specialty, act.description]
        .map((value) => `"${String(value).replaceAll('"', '""')}"`)
        .join(","),
    ),
  ];

  const blob = new Blob([rows.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "actes-standards.csv";
  link.click();
  URL.revokeObjectURL(url);
}
